// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAL94xPUTpfrv0rVT4QbX_rfUwBZG9QZK8",
  authDomain: "sport-tier-app.firebaseapp.com",
  projectId: "sport-tier-app",
  storageBucket: "sport-tier-app.appspot.com",
  messagingSenderId: "514529980279",
  appId: "1:514529980279:web:f2710282790d3aeb49bb72",
  measurementId: "G-XFFG1YW9JG"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);

// 개발 환경에서 에뮬레이터 연결 (필요한 경우)
if (process.env.NODE_ENV === 'development') {
  try {
    // connectFirestoreEmulator(db, 'localhost', 8080);
  } catch (error) {
    console.log('Firestore 에뮬레이터 연결 실패:', error);
  }
}
